(function () {

    // Для таблицы на технической странице
    const tables = document.querySelectorAll('table:not([class])');

    if (!tables) {
        return;
    }

    for (let i = 0; i < tables.length; i++) {
        const wrapper = document.createElement('div');

        wrapper.classList.add('table-container');
        tables[i].parentNode.insertBefore(wrapper, tables[i]);
        wrapper.appendChild(tables[i]);

        // Если таблица содержит заголовок <caption></caption>
        if (tables[i].querySelector('caption')) {
            tables[i].closest('.table-container').classList.add('table-container--with-header-caption');
        } else {
            tables[i].closest('.table-container').classList.add('table-container--without-header-caption');
        }
    }
})();